import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';

export const getTeams = createAsyncThunk('teams/get', async () => {
    const response = await axios.get('team');

    // console.log('getTeams', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const getSharedTeams = createAsyncThunk('teams/shared/get', async () => {
    const response = await axios.get('team/shared');

    // console.log('getSharedTeams', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const connectTeamGeofence = createAsyncThunk(
    'team/connect-geo',
    async ({ teamId, geofenceId }: { teamId: number; geofenceId: number }) => {
        const response = await axios.put(`team/connect/${teamId}/${geofenceId}`);

        // console.log('connectTeamGeofence', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            return false;
        }
    },
);

export const updateTeamName = createAsyncThunk(
    'team/update-name',
    async ({ teamId, name }: { teamId: number; name: string }) => {
        const params = new URLSearchParams();
        params.append('name', name);

        const response = await axios.put(`team/${teamId}`, params);

        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            return false;
        }
    },
);

export const updateTeamImage = createAsyncThunk(
    'team/upload-image',
    async ({ file, teamId }: { file: Blob; teamId: number }) => {
        const formData = new FormData();
        formData.append('file', file, 'team-image.jpg');

        const response = await axios.post(`team/${teamId}/upload/photo?aws=1`, formData);

        if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
            return true;
        } else {
            return false;
        }
    },
);

export const getTeamMembers = createAsyncThunk('teams/members/get', async ({ id }: { id: number }) => {
    const response = await axios.get(`team/${id}/users`);

    // console.log('getTeamMembers', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        return [];
    }
});

export const sendTeamInvite = createAsyncThunk(
    'teams/invite/get',
    async ({ email, phone, teamId }: { email: string; phone: string; teamId: number }) => {
        const response = await axios.get(`team/send-invite?email=${email}&phone=${phone}&teamId=${teamId}`);
        // console.log('getTeamMembers', response.data);

        return response;
    },
);

export const getPendingMembers = createAsyncThunk('teams/pending/get', async ({ id }: { id: number }) => {
    const response = await axios.get(`team/pending/${id}`);

    // console.log('getPendingMembers', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        return [];
    }
});

export const teamDeleteInvite = createAsyncThunk('teams/delete/invite', async ({ id }: { id: number }) => {
    const response = await axios.delete(`team/invite/${id}`);

    // console.log('teamDeleteInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        return false;
    }
});

export const teamDeleteEmailInvite = createAsyncThunk('teams/delete/email-invite', async ({ id }: { id: number }) => {
    const response = await axios.delete(`team/email-invite/${id}`);

    // console.log('teamDeleteEmailInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        return false;
    }
});

export const teamDeleteUser = createAsyncThunk(
    'teams/delete/team-member',
    async ({ userId, teamId, removed = false }: { userId: number; teamId: number; removed?: boolean }) => {
        const response = await axios.delete(`team/${teamId}/user/${userId}`, { data: { removed } });

        // console.log('teamDeleteUser', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return response.data;
        } else {
            return false;
        }
    },
);

export const teamDelete = createAsyncThunk('teams/delete/team', async ({ id }: { id: number }) => {
    const response = await axios.delete(`team/${id}`);

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        return false;
    }
});

export const createTeam = createAsyncThunk('teams/create', async ({ data }: { data: FormData }) => {
    const response = await axios.post(`team`, data);

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        return false;
    }
});

export const getTeamInvites = createAsyncThunk('team/invites/get', async () => {
    const response = await axios.get('team/invites');

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const teamAcceptInvite = createAsyncThunk('team/accept-invite', async ({ id }: { id: number }) => {
    const response = await axios.put(`team/accept-invite/${id}`);

    // console.log('teamAcceptInvite', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return {
            id,
            data: response.data.data,
        };
    } else {
        throw 'error';
    }
});
